
/**
 * Internal dependencies
 */
import Request from './lib/util/request';
import Connection from './lib/connection';
import ConnectionType from './lib/connection-type';
import requestHandler from './lib/util/fetch-request';
import Authentication from './lib/authentication';
import Callback from './lib/callback';
import Install from './lib/install';
import Uninstall from './lib/uninstall';

function AppEcSDK(token) {
	if (!(this instanceof AppEcSDK)) {
		return new AppEcSDK(token);
	}

	if (token) {
		this.token = token;
	} 

	this.request = function(params, fn) {
		params = params || {};
		// token is optional
		if (this.token) {
			params.authToken = this.token;
		}

		return requestHandler(params, fn);
	};
                                  
	// Add Req instance
	this.req = new Request(this);
}

AppEcSDK.prototype.authentication = function() {
    return new Authentication(this);
};
                                                                                                                                                                                                                                                                                                                    
AppEcSDK.prototype.connection = function(id) {
	return new Connection(id, this);                                                                                                                                                                                                                                                                                                                                                                                        
};

AppEcSDK.prototype.connectionType = function(id) {
	return new ConnectionType(id, this);                                                                                                                                                                                                                                                                                                                                                                                        
};

AppEcSDK.prototype.callback = function() {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
    return new Callback(this);
};

AppEcSDK.prototype.install = function() {
    return new Install(this);
};

AppEcSDK.prototype.uninstall = function() {
    return new Uninstall(this);
};

AppEcSDK.Request = Request;

let cecSDK;

if (!cecSDK) {
	cecSDK = AppEcSDK();
}

export default cecSDK;
